import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import ProductPage from './ProductPage';
import Provider from '../../redux/Provider';

const ProductApp = () => (
  <Router>
    <Route path="/products/:slug" component={ProductPage}/>
  </Router>
);

export default Provider(ProductApp);


// WEBPACK FOOTER //
// ./assets/scripts/components/Product/ProductApp.js